<template>
  <div class="">
    <PreLoader v-if="isLoading" />

    <ContractFormForm
      v-if="!isLoading"
      :contractForm="contractForm"
      v-on:addOrUpdateContractForm="addOrUpdateContractForm()"
      :submitName="$t('add')"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import { STATUS } from "@/utils/constants";
import ContractFormForm from "@/components/settings/settingsSalary/contractForms/ContractFormForm.vue";
import ContractForm from "@/models/settings/settingsSalary/contractForms/ContractForm";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ContractFormForm,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      contractForm: new ContractForm(),
    };
  },
  methods: {
    async addOrUpdateContractForm() {
      this.isLoading = true;
      try {
        let response = await this.contractForm.addOrUpdateContractForm(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.contractForm.setInitialValue();
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {},
};
</script>
